import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { TRANSACTION_AMOUNT_TYPE_LIST } from 'src/constants/queryKeys';

export const networkGetTransactionAmountTypeList = async () => {
  const res = await axiosInstance.post('TransactionAmountType/List');
  return res;
};

export function useFetchTransactionAmountTypeList() {
  return useQuery({
    queryKey: [TRANSACTION_AMOUNT_TYPE_LIST],
    queryFn: () => {
      return networkGetTransactionAmountTypeList();
    },
  });
}

export const networkCreateTransactionAmountType = async (data) => {
  const res = await axiosInstance.post('TransactionAmountType/Insert', data);
  return res;
};

export const networkUpdateTransactionAmountType = async (transactionAmountTypeId, data) => {
  const res = await axiosInstance.post(`TransactionAmountType/Update/${transactionAmountTypeId}`, data);
  return res;
};

export const networkRemoveTransactionAmountType = async (transactionAmountTypeId) => {
  const res = await axiosInstance.post(`TransactionAmountType/Remove/${transactionAmountTypeId}`);
  return res;
};
